// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__19gVV","list":"styles_list__4X37U"};